import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { ASSET_TYPE_TYPE, AssetType, AssetsUser, RefCode, RequirementRule } from 'assets-model';
import { AssetTypeDataSource, AssetTypeService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class AssetTypeSearchComponentBase extends CrudListComponent<AssetType, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'assetTypeId', 'comments', 'createdBy', 'createdDate', 'electricalAspectRequirement', 'guidanceText', 'havs', 'havsRagStatus', 'lockVersion', 'maintenanceAspectRequirement', 'maintenanceType', 'mechanicalAspectRequirement', 'name', 'periodicMaintenance', 'periodicMaintenanceDays', 'portableApplianceTestingDays', 'routineMaintenance', 'routineMaintenanceDays', 'transferOnApproval', 'updatedBy', 'updatedDate', 'visualInspection', 'wbv', 'wbvRagStatus', 'actions'];

  public searchForm: FormGroup;

  assetTypeIdFilter: number;
  @ViewChild('assetTypeIdFilterInput') assetTypeIdFilterInput: ElementRef;

  commentsFilter: string;
  @ViewChild('commentsFilterInput') commentsFilterInput: ElementRef;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  electricalAspectRequirementSelectionList: RefCode[];
  electricalAspectRequirementFilter: RequirementRule;
  @ViewChild('electricalAspectRequirementFilterInput') electricalAspectRequirementFilterInput: MatSelect;

  guidanceTextFilter: string;
  @ViewChild('guidanceTextFilterInput') guidanceTextFilterInput: ElementRef;

  havsFilter: boolean;
  @ViewChild('havsFilterInput') havsFilterInput: MatSelect;

  havsRagStatusSelectionList: RefCode[];
  havsRagStatusFilter: string;
  @ViewChild('havsRagStatusFilterInput') havsRagStatusFilterInput: MatSelect;

  maintenanceAspectRequirementSelectionList: RefCode[];
  maintenanceAspectRequirementFilter: RequirementRule;
  @ViewChild('maintenanceAspectRequirementFilterInput') maintenanceAspectRequirementFilterInput: MatSelect;

  maintenanceTypeSelectionList: RefCode[];
  maintenanceTypeFilter: string;
  @ViewChild('maintenanceTypeFilterInput') maintenanceTypeFilterInput: MatSelect;

  mechanicalAspectRequirementSelectionList: RefCode[];
  mechanicalAspectRequirementFilter: RequirementRule;
  @ViewChild('mechanicalAspectRequirementFilterInput') mechanicalAspectRequirementFilterInput: MatSelect;

  nameFilter: string;
  @ViewChild('nameFilterInput') nameFilterInput: ElementRef;

  periodicMaintenanceFilter: boolean;
  @ViewChild('periodicMaintenanceFilterInput') periodicMaintenanceFilterInput: MatSelect;

  periodicMaintenanceDaysFilter: number;
  @ViewChild('periodicMaintenanceDaysFilterInput') periodicMaintenanceDaysFilterInput: ElementRef;
  periodicMaintenanceDaysLessThanFilter: number;
  @ViewChild('periodicMaintenanceDaysLessThanFilterInput') periodicMaintenanceDaysLessThanFilterInput: ElementRef;
  periodicMaintenanceDaysLessThanOrEqualToFilter: number;
  @ViewChild('periodicMaintenanceDaysLessThanOrEqualToFilterInput') periodicMaintenanceDaysLessThanOrEqualToFilterInput: ElementRef;
  periodicMaintenanceDaysGreaterThanFilter: number;
  @ViewChild('periodicMaintenanceDaysGreaterThanFilterInput') periodicMaintenanceDaysGreaterThanFilterInput: ElementRef;
  periodicMaintenanceDaysGreaterThanOrEqualToFilter: number;
  @ViewChild('periodicMaintenanceDaysGreaterThanOrEqualToFilterInput') periodicMaintenanceDaysGreaterThanOrEqualToFilterInput: ElementRef;

  portableApplianceTestingDaysFilter: number;
  @ViewChild('portableApplianceTestingDaysFilterInput') portableApplianceTestingDaysFilterInput: ElementRef;
  portableApplianceTestingDaysLessThanFilter: number;
  @ViewChild('portableApplianceTestingDaysLessThanFilterInput') portableApplianceTestingDaysLessThanFilterInput: ElementRef;
  portableApplianceTestingDaysLessThanOrEqualToFilter: number;
  @ViewChild('portableApplianceTestingDaysLessThanOrEqualToFilterInput') portableApplianceTestingDaysLessThanOrEqualToFilterInput: ElementRef;
  portableApplianceTestingDaysGreaterThanFilter: number;
  @ViewChild('portableApplianceTestingDaysGreaterThanFilterInput') portableApplianceTestingDaysGreaterThanFilterInput: ElementRef;
  portableApplianceTestingDaysGreaterThanOrEqualToFilter: number;
  @ViewChild('portableApplianceTestingDaysGreaterThanOrEqualToFilterInput') portableApplianceTestingDaysGreaterThanOrEqualToFilterInput: ElementRef;

  routineMaintenanceFilter: boolean;
  @ViewChild('routineMaintenanceFilterInput') routineMaintenanceFilterInput: MatSelect;

  routineMaintenanceDaysFilter: number;
  @ViewChild('routineMaintenanceDaysFilterInput') routineMaintenanceDaysFilterInput: ElementRef;
  routineMaintenanceDaysLessThanFilter: number;
  @ViewChild('routineMaintenanceDaysLessThanFilterInput') routineMaintenanceDaysLessThanFilterInput: ElementRef;
  routineMaintenanceDaysLessThanOrEqualToFilter: number;
  @ViewChild('routineMaintenanceDaysLessThanOrEqualToFilterInput') routineMaintenanceDaysLessThanOrEqualToFilterInput: ElementRef;
  routineMaintenanceDaysGreaterThanFilter: number;
  @ViewChild('routineMaintenanceDaysGreaterThanFilterInput') routineMaintenanceDaysGreaterThanFilterInput: ElementRef;
  routineMaintenanceDaysGreaterThanOrEqualToFilter: number;
  @ViewChild('routineMaintenanceDaysGreaterThanOrEqualToFilterInput') routineMaintenanceDaysGreaterThanOrEqualToFilterInput: ElementRef;

  transferOnApprovalFilter: boolean;
  @ViewChild('transferOnApprovalFilterInput') transferOnApprovalFilterInput: MatSelect;

  updatedByFilter: string;
  @ViewChild('updatedByFilterInput') updatedByFilterInput: ElementRef;

  updatedDateFilter: Date;
  @ViewChild('updatedDateFilterInput') updatedDateFilterInput: ElementRef;
  updatedDateLessThanFilter: Date;
  @ViewChild('updatedDateLessThanFilterInput') updatedDateLessThanFilterInput: ElementRef;
  updatedDateLessThanOrEqualToFilter: Date;
  @ViewChild('updatedDateLessThanOrEqualToFilterInput') updatedDateLessThanOrEqualToFilterInput: ElementRef;
  updatedDateGreaterThanFilter: Date;
  @ViewChild('updatedDateGreaterThanFilterInput') updatedDateGreaterThanFilterInput: ElementRef;
  updatedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('updatedDateGreaterThanOrEqualToFilterInput') updatedDateGreaterThanOrEqualToFilterInput: ElementRef;

  visualInspectionFilter: boolean;
  @ViewChild('visualInspectionFilterInput') visualInspectionFilterInput: MatSelect;

  wbvFilter: boolean;
  @ViewChild('wbvFilterInput') wbvFilterInput: MatSelect;

  wbvRagStatusSelectionList: RefCode[];
  wbvRagStatusFilter: string;
  @ViewChild('wbvRagStatusFilterInput') wbvRagStatusFilterInput: MatSelect;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected assetTypeService: AssetTypeService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(ASSET_TYPE_TYPE, route, router, userStorage, dialog, assetTypeService, injector);

    this.searchForm = this.fb.group({
      assetTypeId: [null],
      comments: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      electricalAspectRequirement: [null],
      guidanceText: [null],
      havs: [null],
      havsRagStatus: [null],
      maintenanceAspectRequirement: [null],
      maintenanceType: [null],
      mechanicalAspectRequirement: [null],
      name: [null],
      periodicMaintenance: [null],
      periodicMaintenanceDaysLessThan: [null],
      periodicMaintenanceDaysLessThanOrEqualTo: [null],
      periodicMaintenanceDaysGreaterThan: [null],
      periodicMaintenanceDaysGreaterThanOrEqualTo: [null],
      periodicMaintenanceDays: [null],
      portableApplianceTestingDaysLessThan: [null],
      portableApplianceTestingDaysLessThanOrEqualTo: [null],
      portableApplianceTestingDaysGreaterThan: [null],
      portableApplianceTestingDaysGreaterThanOrEqualTo: [null],
      portableApplianceTestingDays: [null],
      routineMaintenance: [null],
      routineMaintenanceDaysLessThan: [null],
      routineMaintenanceDaysLessThanOrEqualTo: [null],
      routineMaintenanceDaysGreaterThan: [null],
      routineMaintenanceDaysGreaterThanOrEqualTo: [null],
      routineMaintenanceDays: [null],
      transferOnApproval: [null],
      updatedBy: [null],
      updatedDateLessThan: [null],
      updatedDateLessThanOrEqualTo: [null],
      updatedDateGreaterThan: [null],
      updatedDateGreaterThanOrEqualTo: [null],
      updatedDate: [null],
      visualInspection: [null],
      wbv: [null],
      wbvRagStatus: [null]
    });
  }

  createDataSource(): CrudDataSource<AssetType> {
    return new AssetTypeDataSource(this.assetTypeService);
  }

  createServiceArguments(): any {
    return {
      assetTypeId: this.assetTypeIdFilter,
      comments: this.commentsFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      electricalAspectRequirement: this.electricalAspectRequirementFilter,
      guidanceText: this.guidanceTextFilter,
      havs: this.havsFilter,
      havsRagStatus: this.havsRagStatusFilter,
      maintenanceAspectRequirement: this.maintenanceAspectRequirementFilter,
      maintenanceType: this.maintenanceTypeFilter,
      mechanicalAspectRequirement: this.mechanicalAspectRequirementFilter,
      name: this.nameFilter,
      periodicMaintenance: this.periodicMaintenanceFilter,
      periodicMaintenanceDaysLessThan: this.periodicMaintenanceDaysLessThanFilter,
      periodicMaintenanceDaysLessThanOrEqualTo: this.periodicMaintenanceDaysLessThanOrEqualToFilter,
      periodicMaintenanceDaysGreaterThan: this.periodicMaintenanceDaysGreaterThanFilter,
      periodicMaintenanceDaysGreaterThanOrEqualTo: this.periodicMaintenanceDaysGreaterThanOrEqualToFilter,
      periodicMaintenanceDays: this.periodicMaintenanceDaysFilter,
      portableApplianceTestingDaysLessThan: this.portableApplianceTestingDaysLessThanFilter,
      portableApplianceTestingDaysLessThanOrEqualTo: this.portableApplianceTestingDaysLessThanOrEqualToFilter,
      portableApplianceTestingDaysGreaterThan: this.portableApplianceTestingDaysGreaterThanFilter,
      portableApplianceTestingDaysGreaterThanOrEqualTo: this.portableApplianceTestingDaysGreaterThanOrEqualToFilter,
      portableApplianceTestingDays: this.portableApplianceTestingDaysFilter,
      routineMaintenance: this.routineMaintenanceFilter,
      routineMaintenanceDaysLessThan: this.routineMaintenanceDaysLessThanFilter,
      routineMaintenanceDaysLessThanOrEqualTo: this.routineMaintenanceDaysLessThanOrEqualToFilter,
      routineMaintenanceDaysGreaterThan: this.routineMaintenanceDaysGreaterThanFilter,
      routineMaintenanceDaysGreaterThanOrEqualTo: this.routineMaintenanceDaysGreaterThanOrEqualToFilter,
      routineMaintenanceDays: this.routineMaintenanceDaysFilter,
      transferOnApproval: this.transferOnApprovalFilter,
      updatedBy: this.updatedByFilter,
      updatedDateLessThan: this.updatedDateLessThanFilter,
      updatedDateLessThanOrEqualTo: this.updatedDateLessThanOrEqualToFilter,
      updatedDateGreaterThan: this.updatedDateGreaterThanFilter,
      updatedDateGreaterThanOrEqualTo: this.updatedDateGreaterThanOrEqualToFilter,
      updatedDate: this.updatedDateFilter,
      visualInspection: this.visualInspectionFilter,
      wbv: this.wbvFilter,
      wbvRagStatus: this.wbvRagStatusFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.assetTypeIdFilter = null;
    this.commentsFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.electricalAspectRequirementFilter = null;
    this.guidanceTextFilter = null;
    this.havsFilter = null;
    this.havsRagStatusFilter = null;
    this.maintenanceAspectRequirementFilter = null;
    this.maintenanceTypeFilter = null;
    this.mechanicalAspectRequirementFilter = null;
    this.nameFilter = null;
    this.periodicMaintenanceFilter = null;
    this.periodicMaintenanceDaysLessThanFilter = null;
    this.periodicMaintenanceDaysLessThanOrEqualToFilter = null;
    this.periodicMaintenanceDaysGreaterThanFilter = null;
    this.periodicMaintenanceDaysGreaterThanOrEqualToFilter = null;
    this.periodicMaintenanceDaysFilter = null;
    this.portableApplianceTestingDaysLessThanFilter = null;
    this.portableApplianceTestingDaysLessThanOrEqualToFilter = null;
    this.portableApplianceTestingDaysGreaterThanFilter = null;
    this.portableApplianceTestingDaysGreaterThanOrEqualToFilter = null;
    this.portableApplianceTestingDaysFilter = null;
    this.routineMaintenanceFilter = null;
    this.routineMaintenanceDaysLessThanFilter = null;
    this.routineMaintenanceDaysLessThanOrEqualToFilter = null;
    this.routineMaintenanceDaysGreaterThanFilter = null;
    this.routineMaintenanceDaysGreaterThanOrEqualToFilter = null;
    this.routineMaintenanceDaysFilter = null;
    this.transferOnApprovalFilter = null;
    this.updatedByFilter = null;
    this.updatedDateLessThanFilter = null;
    this.updatedDateLessThanOrEqualToFilter = null;
    this.updatedDateGreaterThanFilter = null;
    this.updatedDateGreaterThanOrEqualToFilter = null;
    this.updatedDateFilter = null;
    this.visualInspectionFilter = null;
    this.wbvFilter = null;
    this.wbvRagStatusFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.assetTypeIdFilterInput);
    this.addSearchOnChangedInputEventListener(this.commentsFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedSelectEventListener(this.electricalAspectRequirementFilterInput);
    this.addSearchOnChangedInputEventListener(this.guidanceTextFilterInput);
    this.addSearchOnChangedSelectEventListener(this.havsFilterInput);
    this.addSearchOnChangedSelectEventListener(this.havsRagStatusFilterInput);
    this.addSearchOnChangedSelectEventListener(this.maintenanceAspectRequirementFilterInput);
    this.addSearchOnChangedSelectEventListener(this.maintenanceTypeFilterInput);
    this.addSearchOnChangedSelectEventListener(this.mechanicalAspectRequirementFilterInput);
    this.addSearchOnChangedInputEventListener(this.nameFilterInput);
    this.addSearchOnChangedSelectEventListener(this.periodicMaintenanceFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysFilterInput);
    this.addSearchOnChangedInputEventListener(this.portableApplianceTestingDaysLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.portableApplianceTestingDaysLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.portableApplianceTestingDaysGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.portableApplianceTestingDaysGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.portableApplianceTestingDaysFilterInput);
    this.addSearchOnChangedSelectEventListener(this.routineMaintenanceFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysFilterInput);
    this.addSearchOnChangedSelectEventListener(this.transferOnApprovalFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateFilterInput);
    this.addSearchOnChangedSelectEventListener(this.visualInspectionFilterInput);
    this.addSearchOnChangedSelectEventListener(this.wbvFilterInput);
    this.addSearchOnChangedSelectEventListener(this.wbvRagStatusFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      assetTypeId: (value: number) => self.assetTypeIdFilter = value,
      comments: (value: string) => self.commentsFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      electricalAspectRequirement: (value: RequirementRule) => self.electricalAspectRequirementFilter = value,
      guidanceText: (value: string) => self.guidanceTextFilter = value,
      havs: (value: boolean) => self.havsFilter = value,
      havsRagStatus: (value: string) => self.havsRagStatusFilter = value,
      maintenanceAspectRequirement: (value: RequirementRule) => self.maintenanceAspectRequirementFilter = value,
      maintenanceType: (value: string) => self.maintenanceTypeFilter = value,
      mechanicalAspectRequirement: (value: RequirementRule) => self.mechanicalAspectRequirementFilter = value,
      name: (value: string) => self.nameFilter = value,
      periodicMaintenance: (value: boolean) => self.periodicMaintenanceFilter = value,
      periodicMaintenanceDaysLessThan: (value: number) => self.periodicMaintenanceDaysLessThanFilter = value,
      periodicMaintenanceDaysLessThanOrEqualTo: (value: number) => self.periodicMaintenanceDaysLessThanOrEqualToFilter = value,
      periodicMaintenanceDaysGreaterThan: (value: number) => self.periodicMaintenanceDaysGreaterThanFilter = value,
      periodicMaintenanceDaysGreaterThanOrEqualTo: (value: number) => self.periodicMaintenanceDaysGreaterThanOrEqualToFilter = value,
      periodicMaintenanceDays: (value: number) => self.periodicMaintenanceDaysFilter = value,
      portableApplianceTestingDaysLessThan: (value: number) => self.portableApplianceTestingDaysLessThanFilter = value,
      portableApplianceTestingDaysLessThanOrEqualTo: (value: number) => self.portableApplianceTestingDaysLessThanOrEqualToFilter = value,
      portableApplianceTestingDaysGreaterThan: (value: number) => self.portableApplianceTestingDaysGreaterThanFilter = value,
      portableApplianceTestingDaysGreaterThanOrEqualTo: (value: number) => self.portableApplianceTestingDaysGreaterThanOrEqualToFilter = value,
      portableApplianceTestingDays: (value: number) => self.portableApplianceTestingDaysFilter = value,
      routineMaintenance: (value: boolean) => self.routineMaintenanceFilter = value,
      routineMaintenanceDaysLessThan: (value: number) => self.routineMaintenanceDaysLessThanFilter = value,
      routineMaintenanceDaysLessThanOrEqualTo: (value: number) => self.routineMaintenanceDaysLessThanOrEqualToFilter = value,
      routineMaintenanceDaysGreaterThan: (value: number) => self.routineMaintenanceDaysGreaterThanFilter = value,
      routineMaintenanceDaysGreaterThanOrEqualTo: (value: number) => self.routineMaintenanceDaysGreaterThanOrEqualToFilter = value,
      routineMaintenanceDays: (value: number) => self.routineMaintenanceDaysFilter = value,
      transferOnApproval: (value: boolean) => self.transferOnApprovalFilter = value,
      updatedBy: (value: string) => self.updatedByFilter = value,
      updatedDateLessThan: (value: Date) => self.updatedDateLessThanFilter = value,
      updatedDateLessThanOrEqualTo: (value: Date) => self.updatedDateLessThanOrEqualToFilter = value,
      updatedDateGreaterThan: (value: Date) => self.updatedDateGreaterThanFilter = value,
      updatedDateGreaterThanOrEqualTo: (value: Date) => self.updatedDateGreaterThanOrEqualToFilter = value,
      updatedDate: (value: Date) => self.updatedDateFilter = value,
      visualInspection: (value: boolean) => self.visualInspectionFilter = value,
      wbv: (value: boolean) => self.wbvFilter = value,
      wbvRagStatus: (value: string) => self.wbvRagStatusFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  assetTypeIdChanging(value: number, unsetDependents: boolean = true) {}
  
  assetTypeIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  commentsChanging(value: string, unsetDependents: boolean = true) {}
  
  commentsChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  electricalAspectRequirementLoadSelectionList() {
    this.refCodeStorage.getDomainElements('REQUIREMENT_RULE').subscribe(
      data => {
        this.electricalAspectRequirementSelectionList = data;
      }
    );
  }

  electricalAspectRequirementChanging(value: RequirementRule, unsetDependents: boolean = true) {}
  
  electricalAspectRequirementChanged(value: RequirementRule, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  guidanceTextChanging(value: string, unsetDependents: boolean = true) {}
  
  guidanceTextChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  havsChanging(value: boolean, unsetDependents: boolean = true) {}
  
  havsChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  havsRagStatusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('RAG_STATUS').subscribe(
      data => {
        this.havsRagStatusSelectionList = data;
      }
    );
  }

  havsRagStatusChanging(value: string, unsetDependents: boolean = true) {}
  
  havsRagStatusChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceAspectRequirementLoadSelectionList() {
    this.refCodeStorage.getDomainElements('REQUIREMENT_RULE').subscribe(
      data => {
        this.maintenanceAspectRequirementSelectionList = data;
      }
    );
  }

  maintenanceAspectRequirementChanging(value: RequirementRule, unsetDependents: boolean = true) {}
  
  maintenanceAspectRequirementChanged(value: RequirementRule, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('MAINTENANCE_TYPE').subscribe(
      data => {
        this.maintenanceTypeSelectionList = data;
      }
    );
  }

  maintenanceTypeChanging(value: string, unsetDependents: boolean = true) {}
  
  maintenanceTypeChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  mechanicalAspectRequirementLoadSelectionList() {
    this.refCodeStorage.getDomainElements('REQUIREMENT_RULE').subscribe(
      data => {
        this.mechanicalAspectRequirementSelectionList = data;
      }
    );
  }

  mechanicalAspectRequirementChanging(value: RequirementRule, unsetDependents: boolean = true) {}
  
  mechanicalAspectRequirementChanged(value: RequirementRule, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nameChanging(value: string, unsetDependents: boolean = true) {}
  
  nameChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceChanging(value: boolean, unsetDependents: boolean = true) {}
  
  periodicMaintenanceChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  portableApplianceTestingDaysChanging(value: number, unsetDependents: boolean = true) {}
  
  portableApplianceTestingDaysChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  portableApplianceTestingDaysLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  portableApplianceTestingDaysLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  portableApplianceTestingDaysLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  portableApplianceTestingDaysLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  portableApplianceTestingDaysGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  portableApplianceTestingDaysGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  portableApplianceTestingDaysGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  portableApplianceTestingDaysGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceChanging(value: boolean, unsetDependents: boolean = true) {}
  
  routineMaintenanceChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  transferOnApprovalChanging(value: boolean, unsetDependents: boolean = true) {}
  
  transferOnApprovalChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  visualInspectionChanging(value: boolean, unsetDependents: boolean = true) {}
  
  visualInspectionChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  wbvChanging(value: boolean, unsetDependents: boolean = true) {}
  
  wbvChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  wbvRagStatusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('RAG_STATUS').subscribe(
      data => {
        this.wbvRagStatusSelectionList = data;
      }
    );
  }

  wbvRagStatusChanging(value: string, unsetDependents: boolean = true) {}
  
  wbvRagStatusChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get assetTypeId() {
    return this.searchForm && this.searchForm.get('assetTypeId');
  }

  get comments() {
    return this.searchForm && this.searchForm.get('comments');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get electricalAspectRequirement() {
    return this.searchForm && this.searchForm.get('electricalAspectRequirement');
  }

  get guidanceText() {
    return this.searchForm && this.searchForm.get('guidanceText');
  }

  get havs() {
    return this.searchForm && this.searchForm.get('havs');
  }

  get havsRagStatus() {
    return this.searchForm && this.searchForm.get('havsRagStatus');
  }

  get maintenanceAspectRequirement() {
    return this.searchForm && this.searchForm.get('maintenanceAspectRequirement');
  }

  get maintenanceType() {
    return this.searchForm && this.searchForm.get('maintenanceType');
  }

  get mechanicalAspectRequirement() {
    return this.searchForm && this.searchForm.get('mechanicalAspectRequirement');
  }

  get name() {
    return this.searchForm && this.searchForm.get('name');
  }

  get periodicMaintenance() {
    return this.searchForm && this.searchForm.get('periodicMaintenance');
  }

  get periodicMaintenanceDays() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDays');
  }

  get periodicMaintenanceDaysLessThan() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDaysLessThan');
  }
  
  get periodicMaintenanceDaysLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDaysLessThanOrEqualTo');
  }
  
  get periodicMaintenanceDaysGreaterThan() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDaysGreaterThan');
  }
  
  get periodicMaintenanceDaysGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDaysGreaterThanOrEqualTo');
  }

  get portableApplianceTestingDays() {
    return this.searchForm && this.searchForm.get('portableApplianceTestingDays');
  }

  get portableApplianceTestingDaysLessThan() {
    return this.searchForm && this.searchForm.get('portableApplianceTestingDaysLessThan');
  }
  
  get portableApplianceTestingDaysLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('portableApplianceTestingDaysLessThanOrEqualTo');
  }
  
  get portableApplianceTestingDaysGreaterThan() {
    return this.searchForm && this.searchForm.get('portableApplianceTestingDaysGreaterThan');
  }
  
  get portableApplianceTestingDaysGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('portableApplianceTestingDaysGreaterThanOrEqualTo');
  }

  get routineMaintenance() {
    return this.searchForm && this.searchForm.get('routineMaintenance');
  }

  get routineMaintenanceDays() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDays');
  }

  get routineMaintenanceDaysLessThan() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDaysLessThan');
  }
  
  get routineMaintenanceDaysLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDaysLessThanOrEqualTo');
  }
  
  get routineMaintenanceDaysGreaterThan() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDaysGreaterThan');
  }
  
  get routineMaintenanceDaysGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDaysGreaterThanOrEqualTo');
  }

  get transferOnApproval() {
    return this.searchForm && this.searchForm.get('transferOnApproval');
  }

  get updatedBy() {
    return this.searchForm && this.searchForm.get('updatedBy');
  }

  get updatedDate() {
    return this.searchForm && this.searchForm.get('updatedDate');
  }

  get updatedDateLessThan() {
    return this.searchForm && this.searchForm.get('updatedDateLessThan');
  }
  
  get updatedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateLessThanOrEqualTo');
  }
  
  get updatedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThan');
  }
  
  get updatedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThanOrEqualTo');
  }

  get visualInspection() {
    return this.searchForm && this.searchForm.get('visualInspection');
  }

  get wbv() {
    return this.searchForm && this.searchForm.get('wbv');
  }

  get wbvRagStatus() {
    return this.searchForm && this.searchForm.get('wbvRagStatus');
  }


}



